'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ../~/react-autowhatever/dist/index.js
// module id = 873
// module chunks = 0